import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import { Icons } from '../Icon';
import BaseModal, { ModalList } from '../modals/BaseModal';
import { GET_SMS_TEMPLATES } from '../../graphql/queries';
import { AppContext } from '../../context/AppContext';
import NoContent from '../../shared/NoContent';
import Section from '../../shared/Section';

const ListContainer = styled.ul`
  width: 100%;
  display: grid;
  margin: 0;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  @media screen and (max-width:300px){
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
`;

const ListItem = styled.li`
  word-break: break-word;
  cursor: pointer;
  max-height:100px;
  overflow-y: auto;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  font-size: 15px !important;
  padding: 7px;
  color: #333333;
  list-style-type: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  margin: 10px 10px;
  min-height: 100px;
  font-size: 17px;
  position: relative;
  text-align: start;
  @media screen and (max-width:450px){
    min-height: 50px;
  }
`;

export default function TemplateSection() {
  const { app, setApp } = useContext(AppContext);
  const [templatFormVisible, setTemplatFormVisible] = useState(false);
  const [editData, setEditData] = useState(null);

  const { data, loading, refetch } = useQuery(GET_SMS_TEMPLATES, {
    onCompleted() {
      setApp({ ...app, refetchTemplates: refetch });
    },
  });

  const toolBarButtons = [
    {
      icon: Icons.PlusRegular,
      onClick: () => newButtonClick(),
      text: 'New Template',
    },
  ];

  const newButtonClick = () => {
    setEditData(null);
    setTemplatFormVisible(true);
  };

  const listItemClick = (templateData) => {
    setEditData(templateData);
    setTemplatFormVisible(true);
  };

  return (
    <>
      <BaseModal
        open={templatFormVisible}
        modalType={
          editData ? ModalList.EditTemplateModal : ModalList.AddTemplateModal
        }
        onClose={setTemplatFormVisible}
        editData={editData}
      />
      <Section
        headerTitle="Manage SMS Templates"
        loading={loading}
        toolbarItems={toolBarButtons}
      >
        {data?.templates.length > 0 ? (
          <ListContainer>
            {data.templates.map((item) => (
              <ListItem key={item._id} onClick={() => listItemClick(item)}>
                {item.text}
              </ListItem>
            ))}
          </ListContainer>
        ) : (
          <NoContent
            header="No SMS Templates"
            description='No SMS Templates Please create one by clicking "New Template"'
          />
        )}
      </Section>
    </>
  );
}
